module.exports = __webpack_public_path__ + "214f68481eb9f5bbc025a578723bdd13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/indexLogo@2x.png
// module id = 123
// module chunks = 0